import React, { Fragment, useReducer, useEffect } from "react";
import { toast } from "react-toastify";
import { useAuth0 } from "@auth0/auth0-react";
import ai from "../../helpers/axios";

import { useHistory, useParams } from "react-router-dom";

import TextInput from "../text-input";
import Select from "react-select";

const reducer = (state, action) => {
  switch (action.type) {
    case "fieldChanged": {
      return {
        ...state,
        distanceParam: {
          ...state.distanceParam,
          [action.field]: action.value,
        },
      };
    }

    case "rootFieldChanged": {
      return {
        ...state,
        [action.field]: action.value,
      };
    }
    case "dataBeganDownloading": {
      return {
        ...state,
        loading: true,
      };
    }
    case "dataDownloaded": {
      return {
        ...state,
        loading: false,
        distanceParam: action.payload.data,
      };
    }
    case "aircraftTypesLoaded": {
      return {
        ...state,
        aircraftTypeOptions: action.payload.types.map((item) => ({
          value: item._id,
          label: item.name,
        })),
      };
    }
    default:
      break;
  }
  return state;
};

const SingleDistanceParamContent = (props) => {
  const history = useHistory();
  const { id } = useParams();

  const initialState = {
    loading: true,
    distanceParam: {
      aircraftTypeId: "",
      minDistance: "",
      maxDistance: "",
      bmi: "",
      wind: "",
      mlv: "",
    },
    aircraftTypeOptions: [],
  };

  const { getAccessTokenSilently, loginWithRedirect } = useAuth0();

  const [state, dispatch] = useReducer(reducer, initialState);

  const getData = async () => {
    dispatch({ type: "dataBeganDownloading" });

    const token = await getAccessTokenSilently().catch((e) => {
      console.error(e);
      return loginWithRedirect();
    });

    let { data } = await ai.auth(token).get(`/api/distanceParams/${id}`);

    dispatch({
      type: "dataDownloaded",
      payload: {
        data,
      },
    });
  };

  const loadAircraftTypes = async () => {
    const token = await getAccessTokenSilently().catch((e) => {
      console.error(e);
      return loginWithRedirect();
    });

    const { data } = await ai.auth(token).get("/api/aircraftTypes/list", {
      params: {
        page: 1,
        countPerPage: 100,
      },
    });

    dispatch({
      type: "aircraftTypesLoaded",
      payload: {
        types: data.aircraftTypes || [],
      },
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { aircraftTypeId, minDistance, maxDistance, bmi, wind, mlv } =
      state.distanceParam;

    const numberFields = [minDistance, maxDistance, bmi, wind, mlv];
    if (
      !aircraftTypeId ||
      numberFields.some(
        (value) =>
          value === "" || value === null || Number.isNaN(Number(value))
      )
    ) {
      toast.error("All fields are required.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    const token = await getAccessTokenSilently().catch((e) => {
      console.error(e);
      return loginWithRedirect();
    });

    let formData = {
      aircraftTypeId,
      minDistance: Number(minDistance),
      maxDistance: Number(maxDistance),
      bmi: Number(bmi),
      wind: Number(wind),
      mlv: Number(mlv),
    };

    let { data } = await ai
      .auth(token)
      .put(`/api/distanceParams/${id}`, formData);

    if (data) {
      setTimeout(() => {
        toast.success("Distance Param Updated Successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }, 50);
    }
    history.push({ pathname: "/distance-params" });
  };

  useEffect(() => {
    getData();
    loadAircraftTypes();
    document.title = "Update Distance Param | evoJets HQ";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNumberChange = (e) => {
    dispatch({
      type: "fieldChanged",
      field: e.target.name,
      value: e.target.value,
    });
  };

  const handleAircraftTypeChange = (aircraftType) => {
    dispatch({
      type: "fieldChanged",
      field: "aircraftTypeId",
      value: aircraftType.value,
    });

    return aircraftType;
  };

  const selectedAircraftType =
    state.aircraftTypeOptions.find(
      (item) => item.value === state.distanceParam.aircraftTypeId
    ) || null;

  return (
    <Fragment>
      <h2 id="addAirportHeading">Edit Distance Param</h2>

      <form id="addAirport" onSubmit={handleSubmit}>
        <div className="form-group ml-0">
          <label>Aircraft Type</label>
          <Select
            className="aircraftType-select"
            classNamePrefix="select"
            options={state.aircraftTypeOptions}
            placeholder="Aircraft Type"
            onChange={handleAircraftTypeChange}
            value={selectedAircraftType}
          ></Select>
        </div>

        <TextInput
          type="number"
          name="minDistance"
          value={state.distanceParam.minDistance}
          label="Min Distance"
          handleChange={handleNumberChange}
          step="any"
        ></TextInput>

        <TextInput
          type="number"
          name="maxDistance"
          value={state.distanceParam.maxDistance}
          label="Max Distance"
          handleChange={handleNumberChange}
          step="any"
        ></TextInput>

        <TextInput
          type="number"
          name="bmi"
          value={state.distanceParam.bmi}
          label="BMI"
          handleChange={handleNumberChange}
          step="any"
        ></TextInput>

        <TextInput
          type="number"
          name="wind"
          value={state.distanceParam.wind}
          label="Wind"
          handleChange={handleNumberChange}
          step="any"
        ></TextInput>

        <TextInput
          type="number"
          name="mlv"
          value={state.distanceParam.mlv}
          label="MLV"
          handleChange={handleNumberChange}
          step="any"
        ></TextInput>

        <input type="submit" value="Update Distance Param"></input>
      </form>
    </Fragment>
  );
};

export default SingleDistanceParamContent;
